import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const GroupLinks = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
`;

export const DeleteDrawContainer = styled.div`
  z-index: 1000;
`;

export const FiltersLabel = styled.label`
  width: 100%;
  font: ${theme.font.body[1]};
	letter-spacing: 0px;
	color: ${(props) => props.theme.grey};
`;

export const FileTypeLabel = styled.label`
  font-size: ${theme.font.size16};
  font-weight: bold;
  -webkit-text-decoration: underline;
  text-decoration: underline;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;

  & > div {
    margin-right: 10px;
  }

  & button {
    margin-left: 25px;
    height: 48px;
  }

  @media (max-width: 900px) {
    flex-direction: column;
    margin: 0;

    & div,
    & button {
      width: 100%;
    }

    & button {
      margin: 10px 0;
      margin-bottom: 25px;
    }

    & input {
      width: 100%;
    }
  }
`;

export const LinkFile = styled.span`
  color: ${(props) => props.theme.orange};
  font-size: ${theme.font.size16};
  font-weight: bold;
  text-decoration: underline;
  white-space: normal;
`;

export const Description = styled.span`
  font-size: ${theme.font.size14};
  text-align: center;
  position: relative;
  top: -15px;
`;

export const StatusTag = styled.div`
  margin: 20px 0;
  overflow: visible;

  & div {
    width: fit-content;
  }
`;

export const StatusField = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FormGroup = styled.div`
  display: flex;
  gap: 24px;
  margin: 8px 0 8px 0;

  button {
    margin-top: 8px !important;
    height: 100%;
  }
`;

export const TableContent = styled.div`
    display: flex;
    justify-content: center;
`;

export const TextTable = styled.div`
	color: ${(props) => props.theme.orangeLink};
  text-decoration-color: ${(props) => props.theme.orangeLink};
`;
